// extracted by mini-css-extract-plugin
module.exports = {"description":"ArticleAnalystBox_description__vXrkF"};